import React, { type ReactNode } from 'react';

import {
  findChildOfType,
  applyInternalProps,
} from '../../../services/find-child';

import { File, type FileInternalProps } from './file';
import { useFileUploadContext } from './file-upload-context';

export type FilesProps = {
  children: ReactNode;
  className?: string;
};

export const Files = ({ children, className }: FilesProps) => {
  const { files } = useFileUploadContext();
  const fileElement = findChildOfType(children, Files.File);

  if (!files || files.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {files.map((fileUploadFile, index) =>
        applyInternalProps<FileInternalProps>(fileElement, {
          key: fileUploadFile.file.name || index,
          file: fileUploadFile,
          index,
          focusFile: index === 0,
        }),
      )}
    </div>
  );
};

Files.File = File;
